import { apiGet } from '../http';

export async function getUsers(): Promise<unknown> {
  return await apiGet('/v1/users');
}


